var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H34C37.3137 0 40 2.68629 40 6V20C40 23.3137 37.3137 26 34 26H6C2.68629 26 0 23.3137 0 20V6Z",
    fill: "#6153CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7071 13.7071C31.0976 13.3166 31.0976 12.6834 30.7071 12.2929L24.3431 5.92893C23.9526 5.53841 23.3195 5.53841 22.9289 5.92893C22.5384 6.31946 22.5384 6.95262 22.9289 7.34315L28.5858 13L22.9289 18.6569C22.5384 19.0474 22.5384 19.6805 22.9289 20.0711C23.3195 20.4616 23.9526 20.4616 24.3431 20.0711L30.7071 13.7071ZM11 14L30 14L30 12L11 12L11 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d5f0704512477287c80b4567bd4f0b93.svg";
export { ForwardRef as ReactComponent };